import { Instance, SnapshotIn, types } from "mobx-state-tree";
import { withSetPropAction } from "mobx-stores/_extension/with-set-props";

export const Permission = types
  .model({
    name: types.maybeNull(types.string),
    displayName: types.maybeNull(types.string),
    parentName: types.maybeNull(types.string),
    isGranted: types.optional(types.boolean, false),
    allowedProviders: types.maybeNull(types.frozen<any>()),
    grantedProviders: types.maybeNull(types.frozen<any>()),
  })
  .actions(withSetPropAction);
export interface IPermission extends Instance<typeof Permission> {}
export interface IPermissionProperties extends SnapshotIn<typeof Permission> {}
export const PermisionGroup = types
  .model({
    name: types.string,
    displayName: types.string,
    displayNameKey: types.string,
    displayNameResource: types.string,
    permissions: types.optional(types.array(Permission), []),
  })
  .actions(withSetPropAction);

export interface IPermisionGroup extends Instance<typeof PermisionGroup> {}
export interface IPermisionGroupProperties
  extends SnapshotIn<typeof PermisionGroup> {}

export const PermissionCollection = types
  .model({
    entityDisplayName: types.string,
    groups: types.array(PermisionGroup),
  })
  .actions(withSetPropAction);

export interface IPermissionCollection
  extends Instance<typeof PermissionCollection> {}
export interface IPermissionCollectionProperties
  extends SnapshotIn<typeof PermissionCollection> {}
